"use client";

import React from "react";

export default function page() {
	return (
		<>
			<div className='privacy-wrapper'>
				<style jsx>{`
					.privacy-wrapper {
						background-color: #f5f7fa;
						min-height: 100vh;
						display: flex;
						justify-content: center;
						align-items: flex-start;
						padding: 60px 20px;
						font-family: "Inter", Arial, sans-serif;
						color: #333;
					}

					.privacy-container {
						background: #fff;
						max-width: 900px;
						width: 100%;
						padding: 50px 60px;
						border-radius: 16px;
						box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
					}

					.privacy-title {
						font-size: 2.4rem;
						font-weight: 700;
						color: #111;
						margin-bottom: 10px;
					}

					.privacy-meta {
						color: #666;
						font-size: 0.95rem;
						margin-bottom: 40px;
					}

					h2 {
						font-size: 1.4rem;
						color: #111;
						margin-top: 40px;
						margin-bottom: 12px;
					}

					p {
						line-height: 1.7;
						margin-bottom: 16px;
					}

					ul {
						list-style: disc;
						margin-left: 25px;
						margin-bottom: 16px;
					}

					a {
						color: #cb0505;
						text-decoration: none;
					}

					a:hover {
						text-decoration: underline;
					}

					hr {
						border: none;
						border-top: 1px solid #ddd;
						margin: 30px 0;
					}

					.privacy-footer {
						margin-top: 40px;
						font-size: 0.9rem;
						color: #777;
						text-align: center;
					}

					@media (max-width: 768px) {
						.privacy-container {
							padding: 30px 20px;
						}

						.privacy-title {
							font-size: 2rem;
						}
					}
				`}</style>
				<div className='privacy-container'>
					<div className='wd-content-area site-content'>
						<article
							id='post-13948'
							className='entry-content post-13948 page type-page status-publish hentry'>
							<div
								data-elementor-type='wp-page'
								data-elementor-id={13948}
								className='elementor elementor-13948'>
								<div
									className='wd-negative-gap elementor-element elementor-element-c2f31e4 e-flex e-con-boxed e-con e-parent e-lazyloaded'
									data-id='c2f31e4'
									data-element_type='container'>
									<div className='e-con-inner'>
										<div
											className='elementor-element elementor-element-497650a elementor-widget elementor-widget-wd_text_block'
											data-id='497650a'
											data-element_type='widget'
											data-widget_type='wd_text_block.default'>
											<div className='elementor-widget-container'>
												<div className='wd-text-block reset-last-child text-left'>
													<h1 className='h1'>Termeni și Condiții</h1>

                                                                 <p className='cookies-meta'>
                                                                      Data intrării în vigoare: <strong>21 octombrie 2025</strong> <br />
                                                                 </p>

													<h2 className='h2'>1. Definiții</h2>
													<p className='p'>
														Termenii și condițiile generale prevăzute în
														continuare se vor aplica tuturor vânzărilor de
														bunuri de către Adi-Mag și partenerii săi, prin
														intermediul magazinului virtual{" "}
														<a href='https://www.adi-mag.ro' rel='noopener'>
															www.adi-mag.ro
														</a>{" "}
														către Cumpărător și pot fi modificate oricând de
														către Adi-Mag fără notificare prealabilă.
													</p>
													<p className='p'>
														Astfel, următorii termeni vor însemna:
													</p>
													<p className='p'>
														<strong>Cumpărător</strong> – persoană fizică /
														persoană juridică sau altă entitate juridică ce
														emite o Comandă.
													</p>
													<p className='p'>
														<strong>Vânzător</strong> – Adi-Mag, cu denumirea
														comercială NEGRU ADRIAN PERSOANA FIZICA AUTORIZATA, având sediul social în
														Str. Alexandru Sahia, Nr.15, Cugir, nr. de înregistrare la Registrul
														Comerțului F01/581/2015.
													</p>
													<p className='p'>
														<strong>Bunuri</strong> – orice produs, inclusiv
														documentele și serviciile menționate în Comandă,
														care urmează a fi furnizate de către Vânzător
														Cumpărătorului.
													</p>
													<p className='p'>
														<strong>Comandă</strong> – un document electronic
														ce intervine ca formă de comunicare între Vânzător
														și Cumpărător, prin care Vânzătorul este de acord
														să livreze Bunurile și Cumpărătorul este de acord
														să primească aceste Bunuri și să facă plată
														acestora.
													</p>
													<p className='p'>
														<strong>Contract</strong> – o Comandă confirmată
														de către Vânzător.
													</p>
													<p className='p'>
														<strong>
															Drepturi de Proprietate Intelectuală
														</strong>{" "}
														– toate drepturile imateriale cum ar fi know-how,
														dreptul de autor și drepturi în natură de autor,
														drepturile de bază de date, drepturi de
														proiectare, drepturi de model, patente, mărci
														înregistrate și înregistrări ale numelor de
														domenii pentru oricare din cele de mai sus.
													</p>
													<p className='p'>
														<strong>Site</strong> – domeniul{" "}
														<a href='https://www.adi-mag.ro' rel='noopener'>
															www.adi-mag.ro
														</a>{" "}
														și subdomeniile acestuia.
													</p>
													<h2 className='h2'>2. Documente Contractuale</h2>
													<p className='p'>
														Prin lansarea unei Comenzi electronice pe site-ul{" "}
														<a href='https://www.adi-mag.ro' rel='noopener'>
															www.adi-mag.ro
														</a>
														, Cumpărătorul este de acord cu forma de
														comunicare (e-mail, telefon) prin care Vânzatorul
														își derulează operațiunile. Comanda va fi compusă
														din următoarele documente:
													</p>
													<p className='p'>
														• Comanda (împreună cu mențiunile clare asupra
														datelor de livrare și facturare) și condițiile
														sale specifice.
													</p>
													<p className='p'>• Termeni și condiții</p>
													<p className='p'>
														Daca Vânzătorul confirmă Comanda, acest lucru
														implică o acceptare completă a termenilor
														Comenzii. Acceptarea Comenzii de către Vânzător se
														consideră finalizată atunci când există o
														confirmare electronică (e-mail) din partea
														Vânzătorului către Cumpărător, fără a necesita o
														confirmare de primire din partea acestuia.
														Vânzătorul nu consideră în nici un moment o
														comandă neconfirmată ca având valoarea unui
														Contract.
													</p>
													<p className='p'>
														Confirmarea Comenzii se face electronic (e-mail).
														Prețurile produselor din comandă sunt valabile 3
														zile lucrătoare de la data înregistrării comenzii.
														Termenii și condițiile generale de vânzare vor sta
														la baza Contractului astfel încheiat.
													</p>
                                                                 <p className='p'>
												          Datele personale colectate în cadrul plasării comenzii vor fi prelucrate în conformitate cu Politica de Confidențialitate. Utilizatorul este de acord ca datele sale să fie procesate de Operator și de partenerii menționați în Politică.
													</p>
													<h2 className='h2'>3. Obligațiile Vânzătorului</h2>
													<p className='p'>
														Vânzătorul își va utiliza cunoștințele sale
														profesionale și tehnice pentru a atinge rezultatul
														stipulat în Comandă și va livra Bunurile care
														îndeplinesc cerințele și specificațiile
														Cumpărătorului exprimate în Comandă;
													</p>
													<p className='p'>
														Informațiile prezentate pe site-urile Vânzătorului
														au caracter informativ și pot fi modificate de
														către Vânzător, fără o anunțare prealabilă.
														Descrierile produselor pot fi incomplete, însă
														vânzătorul face eforturi de a prezenta
														informațiile cele mai relevante, pentru ca
														produsul să fie utilizat în parametrii pentru care
														a fost achiziționat;
													</p>
													<h2 className='h2'>
														4. Dreptul de proprietate intelectuală și
														industrială
													</h2>
													<p className='p'>
														Utilizatorul/Cumpărătorul înțelege dreptul de
														proprietate intelectuală și nu va dezvălui unei
														terțe părți sau va face publice nici una dintre
														informările primite de la Vânzător.
													</p>
													<p className='p'>
														Toate desenele, elementele de grafică și design
														care apar pe site, numele site-ului precum și
														însemnele grafice sunt mărci înregistrate în
														proprietatea Adi-Mag și nu pot fi preluate, copiate
														sau folosite, fără acordul scris al
														proprietarului.
													</p>
													<p className='p'>
														Toate elementele de conținut cum sunt descrierile,
														desenele, elementele de grafică și design care
														apar pe site, incluzând dar nelimitându-se la
														logo-uri, reprezentări stilizate, simboluri
														comerciale, imagini statice, imagini dinamice,
														text și/sau conținut multimedia prezentate pe
														site, sunt proprietatea exclusivă a Adi-Mag,
														acestuia fiindu-i rezervate toate drepturile
														obținute în acest sens în mod direct sau indirect
														prin licențe de utilizare și/sau publicare.
													</p>
													<p className='p'>
														Utilizatorului/Cumpărătorului nu îi este permisă
														copierea, distribuirea, publicarea, transferul
														către terțe părți, modificarea și/sau altfel
														alterarea, utilizarea, legarea la, expunerea,
														includerea oricărui element conținut de mai sus în
														orice alt context decât cel original intenționat
														de Adi-Mag, includerea oricărui element de conținut
														în afara Site-ului, îndepărtarea însemnelor care
														semnifică dreptul de autor al Adi-Mag asupra
														elementelor de conținut precum și participarea la
														transferul, vânzarea, distribuția unor materiale
														realizate prin reproducerea, modificarea sau
														afișarea elementelor de conținut, decât cu acordul
														scris expres al Adi-Mag.
													</p>
													<h2 className='h2'>
														5. Drepturile asupra conținutului site-ului
													</h2>
													<p className='p'>
														Întreg continutul site-ului si elementele de
														grafica, inclusiv dar fara a se limita la acestea,
														respectiv tot continutul in format text, precum si
														sursele tehnice ale tuturor serviciilor si
														facilitatilor prezente si viitoare – cu exceptia
														cazului cand este mentionat expres un alt
														proprietar – sursele paginilor dar si orice alt
														material, transmis sub orice forma de si catre
														Utilizatori (prin vizualizare directa pe site,
														prin newslettere etc.) apartin Adi-Mag.
													</p>
													<p className='p'>
														Continutul site-ului, indiferent de zona in care
														se afla in site si indiferent de tip, poate fi
														utilizat exclusiv in scopuri personale. Orice
														utilizare de continut de catre terte persoane in
														alte scopuri decat cel personal, se poate face
														numai cu acordul scris, expres si prealabil al
														Adi-Mag. Prin urmare, este interzisa copierea,
														preluarea, reproducerea, publicarea, transmiterea,
														vanzarea, distributia partiala, integrala sau
														modificata a continutului acestui site sau a
														oricarei parti a acestuia efectuate in alte
														scopuri decat cel personal, cu urmatoarele
														exceptii:
													</p>
													<p className='p'>
														(i) este permisa reproducerea (pe site-uri
														noncomerciale, forumuri, articole din presa etc.)
														a unor mici fragmente din articolele publicate
														(max. 400 de caractere), fiind obligatorie
														specificarea sursei informatiilor preluate, cu
														link, sub urmatoarea forma: (Sursa: nume site –
														link catre continutul site-ului).
													</p>
													<p className='p'>
														(ii) sunt permise link-urile catre site-ul{" "}
														<a href='https://www.adi-mag.ro' rel='noopener'>
															www.adi-mag.ro
														</a>
														, iar specificarea sursei informatiilor se va face
														dupa fiecare link sau in finalul articolului, dupa
														cum urmeaza: „Informatii furnizate prin
														amabilitatea Adi-Mag – link catre continutul
														site-ului)
													</p>
													<p className='p'>
														Utilizatorii se obliga sa respecte toate
														drepturile de autor si toate drepturile conexe
														acestuia si orice alte drepturi de proprietate
														intelectuala pe care Administratorul site-ului si
														partenerii sai le detin asupra/in legatura cu
														site-ul{" "}
														<a href='https://www.adi-mag.ro' rel='noopener'>
															www.adi-mag.ro
														</a>
														.
													</p>
													<p className='p'>
														Adi-Mag isi rezerva dreptul de a actiona in
														instanta orice persoana si/sau entitate care
														incalca in orice mod prevederile de mai sus.
														Cererile de utilizare a continutului site-ului in
														orice scop altul decat cel personal pot fi facute
														prin e-mail la adresa{" "}
														<a href='mailto:contact@Adi-Mag.ro'>contact@Adi-Mag.ro</a>
														, cu specificatia „In atentia agenției”.
													</p>
													<p className='p'>
														Orice persoana care transmite sau publica in orice
														mod informatii ori materiale catre site isi asuma
														obligatia de a nu prejudicia in nici un mod
														drepturile de autor pe care o terta persoana le-ar
														putea invoca in legatura cu materialele si
														informatiile transmise in orice mod catre site,
														iar persoanele care expediaza in orice mod
														informatii ori materiale inteleg si accepta ca
														incalcarea in orice mod a acestei obligatii nu
														poate angaja in niciun mod raspunderea Adi-Mag, ci
														numai raspunderea persoanelor respective.
													</p>
													<p className='p'>
														Adi-Mag poate derula in orice moment campanii
														publicitare si/sau promotii in orice sectiune din
														site, fara ca aceasta operatiune sa necesite
														acordul Utilizatorilor site-ului. Spatiile si
														dimensiunea campaniilor publicitare si promotiilor
														nu necesita acordul Utilizatorilor site-ului si
														pot fi schimbate oricand fara a necesita anuntarea
														prealabila.
													</p>
													<p className='p'>
														Adi-Mag nu isi asuma responsabilitatea pentru
														prejudiciile sau pierderile rezultate din
														campaniile publicitare sau promotiile organizate
														in site, altele decat cele organizate strict pe
														site.
													</p>
													<h2 className='h2'>
														6. Limitarea răspunderii administratorului
														site-ului
													</h2>
													<p className='p'>
														Adi-Mag nu isi asuma obligatia si nu garanteaza
														implicit sau expres, pentru continutul site-ului,
														respectiv pentru continutul oferit de partenerii
														sai sau de Utilizatorii site-ului. Cu toate
														acestea, Adi-Mag va depune toate eforturile
														rezonabile pentru a asigura acuratetea si maniera
														profesionista in care vor fi furnizate
														informatiile pe site, pentru a dobandi si mentine
														increderea Utilizatorilor in site. In acest sens,
														Adi-Mag va incerca sa corecteze in cel mai scurt
														timp posibil erorile si omisiunile semnalate.
													</p>
													<p className='p'>
														Administratorul site-ului nu ofera niciun fel de
														garantii pentru continutul site-ului si in nicio
														situatie nu poate fi tinut raspunzator pentru
														nicio pierdere sau prejudiciu ce ar putea rezulta
														din utilizarea oricarei parti/secvente/pagini de
														pe site sau din imposibilitatea utilizarii
														acesteia, indiferent de cauza acesteia ori din
														interpretarea eronata a oricaror prevederi ale
														continutului site-ului.
													</p>
													<p className='p'>
														Informatiile furnizate prin intermediul site-ului
														sunt oferite cu buna-credinta, din surse apreciate
														ca fiind de incredere. In cazul in care vreunul
														din articolele publicate sau orice alta informatie
														intra sub incidenta legii dreptului de autor,
														rugam Utilizatorii sa ne contacteze la adresa de
														e-mail{" "}
														<a href='mailto:contact@Adi-Mag.ro'>
															contact@Adi-Mag.ro
														</a>
														, pentru a putea lua masurile ce se impun.
														Totodată, Utilizatorii trebuie sa aibă în vedere
														faptul ca informatia prezentata poate include
														eventuale informatii inexacte (de ex.: date de
														ordin tehnic sau erori de tastat). Administratorul
														site-ului va face toate diligentele necesare
														pentru a corecta in cel mai scurt timp posibil
														aceste aspecte.
													</p>
													<p className='p'>
														Utilizatorii inteleg si accepta faptul ca Adi-Mag
														nu garanteaza:
													</p>
													<p className='p'>
														• ca informatiile continute pe site sunt pe deplin
														complete;
													</p>
													<p className='p'>
														• ca informatiile introduse de Utilizatorii
														website-ului sunt reale, corecte si nu isi asuma
														raspunderea pentru modul in care vizitatorii le
														folosesc;
													</p>
													<p className='p'>
														• ca informatiile sau serviciile de pe site vor
														satisface toate cerintele Utilizatorilor, iar
														pentru folosirea inadecvata a acestora
														Utilizatorii isi asuma intreaga responsabilitate;
													</p>
													<p className='p'>
														• pentru rezultatele obtinute de Utilizatori ca
														urmare a folosirii informatiilor sau serviciilor
														disponibile prin intermediul site-ului utilizarea
														informatiilor si a serviciilor facandu-se de catre
														Utilizatori pe propria raspundere;
													</p>
													<p className='p'>
														• ca serviciile disponibile prin intermediul
														site-ului vor functiona constant, neintrerupt,
														fara erori – fata de acest aspect, Adi-Mag nu isi
														asuma responsabilitatea pentru eventualele pagube
														pe care Utilizatorii le-ar putea avea din cauza
														nefunctionarii temporare sau defectuoase a
														site-ului sau pentru folosirea informatiilor
														obtinute prin utilizarea link-urilor de pe site
														catre alte site-uri (utilizarea lor este la
														latitudinea Utilizatorilor).
													</p>
													<p className='p'>
														De asemenea, Utilizatorii inteleg si accepta
														faptul ca Adi-Mag nu este responsabila pentru
														eventuale inadvertente, erori sau omisiuni in
														cadrul informatiilor furnizate pe site de catre
														Utilizatori. Totodata, Utilizatorii inteleg si
														accepta ca Adi-Mag este absolvita de orice
														raspundere pentru mesajele publicitare postate pe
														site sau prin intermediul serviciilor oferite prin
														site, precum si pentru bunurile sau serviciile
														furnizate de catre autorii acestor mesaje
														publicitare. In mod expres, Utilizatorii site-ului
														sunt de acord sa exonereze de raspundere Adi-Mag
														pentru orice actiune judiciara sau extrajudiciara,
														care provine ca urmare a utilizarii incorecte sau
														frauduloase a site-ului.
													</p>
													<p className='p'>
														Pentru cazuri de forta majora, Adi-Mag si/sau
														operatorii, directorii, angajatii, sucursalele,
														filialele si reprezentantii sai, este exonerata
														total de orice raspundere. Cazurile de forta
														majora includ, dar nu se limiteaza la, erori de
														functionare ale echipamentului tehnic al Adi-Mag,
														lipsa functionarii conexiunii la internet, lipsa
														functionarii conexiunilor de telefon, virusii
														informatici, accesul neautorizat in sistemele
														Site-ului, erorile de operare, etc.
													</p>
													<p className='p'>
														Utilizatorii sunt de acord sa protejeze si sa
														asigure Adi-Mag si/sau pe operatorii, directorii,
														angajatii, sucursalele, filialele si
														reprezentantii sai de si impotriva oricaror
														cereri, pretentii, actiuni, impuneri, pierderi,
														daune, costuri (incluzand, fara nici un fel de
														limitare, onorariile avocatilor), cheltuieli,
														judecati, decizii, amenzi, regularizari sau alte
														obligatii rezultate sau relationate cu orice alta
														actiune a Utilizatorilor in legatura cu utilizarea
														site-ului sau a serviciilor oferite prin
														intermediul acestuia.
													</p>
													<p className='p'>
														Adi-Mag nu ofera nicio garantie, nici in mod expres
														si nici implicit, in ceea ce priveste inclusiv,
														dar fara limitare la functionarea site-ului{" "}
														<a href='https://www.adi-mag.ro' rel='noopener'>
															www.adi-mag.ro
														</a>
														, informatia, continutul, materialele sau
														produsele de pe site, precum si potrivirea lor
														pentru un anumit scop. Utilizatorii sunt de acord
														in mod expres ca folosirea acestui site si
														aplicarea informatiilor se face pe propriul lor
														risc.
													</p>
													<h2 className='h2'>
														7. Abonarea Utilizatorilor la newslettere și
														alerte
													</h2>
													<p className='p'>
														Utilizatorii site-ului au posibilitatea de a primi
														newslettere si alerte prin posta electronica,
														existand posibilitatea ca Utilizatorii sa poata
														opta oricand pentru varianta de a nu mai primi
														astfel de notificari, cu un singur click pe
														link-ul de dezabonare din newsletter/alerta
														primita pe mailul introdus explicit la abonare.
													</p>
													<p className='p'>
														Fata de faptul ca accesul la produsele oferite
														prin intermediul site-ului se realizeaza prin
														intermediul unui cont activ, asadar pe baza unui
														nume de utilizator si a unei parole, recomandam
														Utilizatorilor ca aceste elemente sa nu fie
														dezvaluite unor terte persoane, chiar daca acestea
														afirma ca va contacteaza din partea site-ului.
													</p>
													<p className='p'>
														De asemenea, in vederea asigurarii unui nivel
														sporit de securitate, la sfarsitul vizitei pe site
														recomandam inchiderea ferestrei browser-ului in
														care s-a lucrat sau click pe „Sign out”/”Log off”
														in pagina vizitata.
													</p>
													
													
													<h2 className='h2'>9. Facturare și plăți</h2>
													<p className='p'>
														Prețul, modalitatea de plată și termenul de plată
														sunt specificate în Comandă. Vânzătorul va emite
														către Cumpărător o factură pentru Bunurile
														livrate, obligația Cumpărătorului fiind să
														furnizeze toate informațiile necesare emiterii
														facturii conform cu legislația în vigoare.
													</p>
													<p className='p'>
														Pentru o corectă comunicare a facturii aferente
														Comenzii, Cumpărătorului îi revin obligațiile de
														a-și actualiza ori de câte ori este cazul datele
														din Contul său și de a accesa informațiile și
														documentele aferente fiecărei Comenzi existente în
														Cont.
													</p>
													<p className='p'>
														Prin trimiterea Comenzii, Cumpărătorul își exprimă
														acordul să primească facturile și în format
														electronic prin intermediul poștei electronice, la
														adresa de e-mail menționată în Contul său.
													</p>
													<h2 className='h2'>10. Responsabilități</h2>
													<p className='p'>
														Vânzătorul se obligă să expedieze Bunurile și
														Serviciile în sistem de curierat door-to-door
														către Cumpărător.
													</p>
													<p className='p'>
														Vânzătorul se eliberează de riscurile și
														responsabilitățile asociate cu Bunurile și
														Serviciile în momentul predării acestora către
														societatea de curierat intern cu care Vânzătorul
														colaborează sau către reprezentantul
														Cumpărătorului.
													</p>
													<p className='p'>
														Vânzătorul va asigura ambalarea corespunzătoare a
														Bunurilor și Serviciilor și va asigura
														transmiterea documentelor însoțitoare.
													</p>
													<p className='p'>
														Vânzătorul nu poate fi responsabil pentru daune de
														orice fel pe care Cumpărătorul sau oricare terță
														parte o poate suferi ca rezultat al îndeplinirii
														de către Vânzător a oricărei din obligațiile sale
														conform Comenzii și pentru daune care rezultă din
														utilizarea Bunurilor după livrare și în special
														pentru pierderea produselor. Vânzătorul va fi
														răspunzător în cazul în care sub-contractanții
														și/sau partenerii săi de orice fel implicați în
														executarea Comenzii nu îndeplinesc oricare din
														obligațiile contractuale.
													</p>
													<p className='p'>
														Vânzătorul nu își asumă responsabilitatea pentru
														descrierile produselor prezentate pe site.
														Imaginile sunt prezentate pe site cu titlu de
														exemplu, iar produsele livrate pot diferi de
														imaginile și descrierile expuse pe site în orice
														mod, datorită modificării caracteristicilor și
														design-ului fără notificare prealabilă. Vânzătorul
														își rezervă dreptul să completeze și să modifice
														orice informație de pe site fără notificare
														prealabilă.
													</p>
													<p className='p'>
														Vânzătorul nu garantează disponibilitatea în stoc
														a produselor afișate, motiv pentru care va avea
														dreptul de a nu livra parțial sau integral o
														anumită comandă în cazul în care anumite produse
														nu mai apar în oferta curentă sau nu sunt
														disponibile.
													</p>
													<p className='p'>
														În cazul în care prețurile sau alte detalii
														referitoare la produse au fost afișate greșit,
														inclusiv din cauza faptului că au fost introduse
														greșit în baza de date, Vânzătorul își alocă
														dreptul de a anula livrarea respectivului produs
														și de a anunța clientul în cel mai scurt timp
														despre eroarea aparută, dacă livrarea nu s-a
														efectuat încă.
													</p>
													<p className='p'>
														Vânzătorul nu răspunde pentru prejudiciile create
														ca urmare a nefuncționării site-ului precum și
														pentru cele rezultând din imposibilitatea
														accesării anumitor link-uri publicate pe site.
													</p>
													<p className='p'>
														Valoarea maximă a obligațiilor Vânzătorului față
														de orice client în cazul nelivrării sau livrării
														necorespunzătoare este valoarea sumelor încasate
														de Vânzător de la clientul respectiv.
													</p>
													<p className='p'>
														Produsele comercializate pe site sunt destinate
														utilizării personale, iar revânzarea acestora este
														strict interzisă, conform Codului Fiscal.
													</p>
													<h2 className='h2'>11. Livrarea produselor</h2>
													<p className='p'>
														Livrarea nu este gratuită și se face prin curier
														rapid așa cum este descrisă în secțiunea
														„Livrări”.
													</p>
													<p className='p'>
														Produsele noastre sunt realizate câteodată pe bază
														de comandă, ceea ce face ca durata de producție și
														livrare să fie de până la 14 zile lucrătoare
														începând cu ziua procesării comenzii.
													</p>
													<p className='p'>
														Comenzile sunt procesate cât mai curând după
														plasarea comenzii, în intervalul Luni – Vineri
														10:00-18:00. În cazul comenzilor plasate în afara
														orelor de program (Luni – Vineri 10:00-18:00) sau
														în weekend, acestea vor fi procesate în prima zi
														lucrătoare. De sărbători și în perioadele de
														reduceri, termenul de livrare se poate prelungi.
													</p>
													<p className='p'>
														Dacă pachetul nu poate fi livrat (destinatarul nu
														răspunde, adresa specificată de dumneavoastră este
														greșită etc), veți fi contactat telefonic de către
														curier. Dacă nu se poate lua contact cu
														destinatarul, coletele rămân la curierul zonal 7
														zile, după care revin la Expeditor.
													</p>
													<p className='p'>
														Nu suntem răspunzători pentru expedieri
														întârziate, pierderea, distrugerea, deteriorarea,
														ne livrarea sau livrarea greșită a unei expedieri
														sau a unei părți din aceasta în cazul în care sunt
														generate de situații/circumstanțe independente de
														voința noastră (blocaje rutiere, cauze naturale
														sau umane, nerespectarea comenzilor de către
														furnizori și terți etc.).
													</p>
													<h2 className='h2'>12. Acceptarea</h2>
													<p className='p'>
														Acceptarea va fi facută atunci când Bunurile sunt
														conforme cu caracteristicile tehnice menționate în
														Comandă. În cazul în care Cumpărătorul descoperă
														că Produsele livrate nu sunt conforme
														specificațiilor tehnice, atunci Vânzătorul va
														aduce la conformitate Produsele. De asemenea,
														pentru produsele vândute și livrate de Adi-Mag,
														Cumpărătorul beneficiază de returul produselor în
														14 zile.
													</p>
													<h2 className='h2'>13. Transferul proprietății</h2>
													<p className='p'>
														Proprietatea asupra Bunurilor va fi transferată la
														livrare, după efectuarea plății din partea
														Cumpărătorului în locația indicată în comandă
														(întelegând prin livrare – semnarea de primire a
														documentului de transport furnizat de curier sau
														semnarea de primire pe factura fiscală în cazul
														livrărilor efectuate de personalul Vânzătorului).
														În cazul livrării prin curier, acesta nu este
														autorizat de către Vânzător să permită
														Cumpărătorului deschiderea coletelor înainte de
														semnarea de livrare, ci doar ulterior semnării de
														livrare și achitării eventualei contravalori a
														acestora.
													</p>
													<h2 className='h2'>14. Returnarea produselor</h2>
													<p className='p'>
														Cumpărătorul poate solicita returnarea produselor
														în următoarele situații:
													</p>
													<p className='p'>
														• Coletele prezintă deteriorări severe;
													</p>
													<p className='p'>
														• Produsele au fost livrate / facturate greșit.
														Livrarea altor produse decât cele solicitate
														trebuie semnalată imediat. Cumpărătorul poate
														solicita returnarea acestuia pentru înlocuire, iar
														dacă produsul nu mai este pe stoc, poate opta
														pentru înlocuire sau rambursarea integrală a
														contravalorii. Daca se agreează înlocuirea cu un
														produs de o valoare mai mare, va plăti diferența,
														respectiv dacă valoarea este mai mică, va primi o
														rambursare parțială până la valoarea produsului
														înlocuitor. Costurile de retur și de transport
														pentru produsul înlocuitor, dacă este cazul, sunt
														suportate de client.
													</p>
													<p className='p'>
														• Produsele prezintă defecte de fabricație;
													</p>
													<p className='p'>
														Cumpărătorul are dreptul să notifice în scris
														Vânzătorului că renunța la cumpărare, fără
														penalități şi fără invocarea unui motiv, în termen
														de 14 zile de la primirea produsului. De asemenea,
														în conformitate cu art. 7 alin. 1 din O.G.
														130/2000, Cumpărătorul are dreptul de a denunța
														unilateral contractul la distanță, în scris, în
														termen de 14 zile de la data primirii
														produsului/produselor, fără penalități și fără
														invocarea vreunui motiv. În acest caz,
														cheltuielile directe de returnare a produselor vor
														cădea, conform legii, în sarcina Cumpărătorului.
													</p>
													<p className='p'>
														Produsele trebuie să fie returnate în ambalajul
														original, cu factura atașată, să nu prezinte urme
														de uzură fizică sau deteriorare.
													</p>
													<p className='p'>
														Produsele personalizate nu pot fi returnate. Vă
														rugăm să aveți în vedere că aceste produse sunt
														create după configurațiile specificate de
														dumneavoastră, deci nu pot fi schimbate sau
														returnate.
													</p>
													<p className='p'>
														Dacă se agreează înlocuirea cu un produs de o
														valoare mai mare, Cumpărătorul va plăti diferența,
														respectiv dacă valoarea este mai mică, va primi o
														rambursare parțială până la valoarea produsului
														înlocuitor. Costurile de retur și de transport
														pentru produsul înlocuitor, dacă este cazul, sunt
														suportate de Cumpărător. În cazul în care
														produsele a căror returnare se solicită prezintă
														ambalaje deteriorate sau incomplete, urme de
														uzură, zgârieturi, lovituri, ne rezervăm dreptul
														de a decide acceptarea returului sau de a opri o
														sumă, suma ce va fi comunicată după evaluarea
														prejudiciilor aduse.
													</p>
													<p className='p'>
														În cazul exercitării dreptului legal de returnare
														a produsului, rambursarea contravalorii acestuia
														se va face prin virament bancar în contul indicat
														de Cumpărător în cel mult 14 de zile de la
														primirea produsului returnat.
													</p>
													<h2 className='h2'>
														15. Prelucrarea datelor cu caracter personal
													</h2>
													<p className='p'>
														Pentru a asigura respectarea dreptului
														utilizatorilor site-ului la protecția datelor cu
														caracter personal, am implementat măsuri specifice
														de protecție, luând în considerare legislația
														română, precum și cerințele stabilite de
														Regulamentul (UE) 2017/679 – aplicabil în întreaga
														Uniune Europeană începând cu data de 25 mai 2018
														(„Regulamentul”).
													</p>
													<p className='p'>
														Datele cu caracter personal reprezintă orice
														informație prin care dvs. puteți fi identificat,
														în special printr-un element de identificare cum
														ar fi un nume, un număr de identificare, date de
														localizare, un identificator online sau unul sau
														mai multe elemente aflate în legătură cu
														identitatea dvs. fizică, fiziologică, genetică,
														psihică, economică, culturală sau socială.
													</p>
													<p className='p'>
														Societatea noastră ia toate măsurile necesare
														pentru a asigura respectarea dreptului dvs. la
														protecția datelor cu caracter personal, iar
														prezentele condiţii reprezintă notificarea
														stabilită de art. 13 sau 14 din Regulament prin
														care explicăm de ce colectăm datele dvs. cu
														caracter personal, modul în care protejăm aceste
														date, precum și care sunt drepturile dvs. în
														legătură cu această colectare de date.
													</p>
													<p className='p'>
														Vă încurajăm să citiți cu atenție documentul și să
														ne solicitați orice informație suplimentară sau
														orice lămurire pe care o considerați necesară, cu
														privire la conținutul acestei informări.
													</p>
													<h3 className='h2'>
														1) Considerații generale privind datele
														dumneavoastră personale
													</h3>
													<p className='p'>
														In conformitate cu Regulamentul (UE) 2017/679,
														Adi-Mag va administra in conditii de siguranta si
														numai pentru scopurile specificate, datele
														personale furnizate de Utilizatori. Prin Termeni
														si Conditii Utilizatorii sunt informati ca datele
														personale pe care le furnizeaza urmeaza a fi
														prelucrate in scopul oferirii in conditii optime
														de catre Adi-Mag a serviciilor pe internet, a
														serviciilor de furnizare bunuri si servicii, a
														serviciilor de reclama, marketing si publicitate
														si a serviciilor de statistica.
													</p>
													<p className='p'>
														Adi-Mag realizează următoarele operaţiuni de
														prelucrare: colectarea, inregistrarea,
														organizarea, stocarea, adaptarea, modificarea,
														extragerea, consultarea, utilizarea si, in unele
														cazuri, transmiterea catre terti, in baza
														exclusiva si reglementata a unui contract
														comercial care asigura securitatea si
														confidentialitatea datelor, precum si respectarea
														drepturilor utilizatorului, a datelor personale
														ale Utilizatorilor site-ului pentru a administra,
														mentine, imbunatati si obtine informaţii cu
														privire la serviciile pe care le ofera, precum si
														pentru a preveni erori si scurgeri de informatii
														prin reteaua IT proprie, incalcari ale legii sau
														termenilor contractuali.
													</p>
													<p className='p'>
														Datele personale ce urmeaza a fi colectate vor
														putea fi folosite, inclusiv prin crearea automată
														de profiluri (pentru acei Utilizatori care şi-au
														exprimat consimţământul explicit) si pentru a
														personaliza intr-un grad cat mai mare serviciile
														oferite Utilizatorilor prin intermediul site-ului
														precum si in scopuri de marketing. Crearea
														automată de profiluri nu va viza datele minorilor,
														datele personale ale acestora nefiind prelucrate
														în acest scop.
													</p>
													<p className='p'>
														Datele personale vor fi furnizate de catre
														Utilizatori, la optiunea lor proprie, in momentul
														crearii unui cont valabil pe site sau abonarii la
														un serviciu disponibil pe site, pentru a beneficia
														de serviciile si produsele oferite prin
														intermediul acestuia. La inregistrarea in site
														sunt solicitate Utilizatorului anumite date
														personale, precum numele si prenumele, sexul, data
														nasterii, adresa de e-mail, telefon, profesie,
														obisnuinte/preferinte/comportament, dar si alte
														informatii cu caracter personal.
													</p>
													<p className='p'>
														Utilizatorul este singurul raspunzator de toate
														datele furnizate la momentul crearii contului de
														utilizator pe site. Pentru confirmarea datelor si
														contului, Utilizatorul va fi anuntat la adresa de
														e-mail declarata la crearea contului. Acest e-mail
														de confirmare are rolul stoparii actiunilor
														frauduloase ale unor utilizatori care folosesc
														adrese de e-mail ale altor persoane pentru a crea
														conturi fictive. Daca primiti un asemenea mesaj,
														in conditiile in care nu v-ati inregistrat
														personal pe site va rugam sa ne trimiteti un
														e-mail la adresa{" "}
														<a href='mailto:contact@adi-mag.ro'>
															contact@adi-mag.ro
														</a>
														pentru a sterge contul respectiv in maximum 3 zile
														lucratoare. E-mailul va conţine, în format pdf şi
														versiunea în vigoare a prezentului Contract.
													</p>
													<p className='p'>
														Formularul de profil al Utilizatorului contine
														campuri care pot fi editate in cazul in care se
														doreste modificarea sau completarea datelor
														furnizate la crearea contului.
													</p>
													<p className='p'>
														Utilizatorul nu este obligat sa furnizeze aceste
														date, ele fiind necesare i) evidentei despre
														folosirea site-ului si ii) al oferirii in conditii
														optime a serviciilor prin intermediul acestuia,
														pentru aducerea la cunostinta a campaniilor
														promotionale, in scop de reclama, pentru actiuni
														de marketing si publicitate personalizate si
														pentru accesul Utilizatorului la facilitati
														suplimentare. Refuzul Utilizatorului de a furniza
														datele solicitate determina neparticiparea la
														actiunile promotionale organizate prin intermediul
														site-ului si nefolosirea facilitatilor,
														serviciilor suplimentare oferite exclusiv
														Utilizatorilor cu un cont in acest website.
													</p>
													<p className='p'>
														Website-ul va putea fi utilizat şi dacă
														Utilizatorul decide să nu creeze un profil prin
														furnizarea datelor personale, cu excepţiile
														stabilite în cadrul Politicii de Cookies (parte
														integrantă a prezentului Contract)
													</p>
													<p className='p'>
														Conform Regulamentul (UE) 2017/679 si Legii nr.
														677/2001, Utilizatorii beneficiaza de dreptul de
														acces, de interventie asupra datelor, dreptul de a
														nu fi supus unei decizii individuale si dreptul de
														a se adresa justitiei. Totodata, Utilizatorii au
														dreptul sa se opuna prelucrarii datelor personale
														care ii privesc si sa solicite stergerea datelor.
													</p>
													<p className='p'>
														Pentru exercitarea acestor drepturi, Utilizatorii
														pot face o cerere in scris in acest sens, pe care
														o vor trimite prin e-mail la adresa{" "}
														<a href='mailto:contact@Adi-Mag.ro'>
															contact@Adi-Mag.ro
														</a>
														cu specificația „Solicitare date cu caracter
														personal”.
													</p>
													<p className='p'>
														Site-ul se angajează sa nu trimită mesaje spam
														(mesaje comerciale pentru care nu are acceptul
														prealabil explicit al Utilizatorului) si sa
														întreprindă toate mijloacele tehnice accesibile
														pentru a asigura securitatea si confidențialitatea
														datelor utilizatorului.
													</p>
													<p className='p'>
														Site-ul își rezerva dreptul de a desființa, fără
														aviz prealabil, conturile si accesul membrilor
														care încalcă Termenii și condițiile, care
														întreprind activități dovedite de frauda, calomnie
														sau atac la securitatea și confidențialitatea
														informațiilor din cadrul site-ului sau a companiei
														operatoare a site-ului.
													</p>
													<h3 className='h2'>
														2) Datele având caracter personal pe care le
														colectăm, temeiurile colectării și scopurile
														colectării
													</h3>
													<p className='p'>
														În cadrul raportului de comunicare online stabilit
														intre site și utilizator, colectăm și prelucrăm
														datele dvs. având caracter personal, colectarea și
														prelucrarea acestor date fiind necesară furnizării
														de conținut informativ si promoțional către
														utilizator, în urma completării, de către acesta,
														a datelor cu caracter personal în mod voluntar, în
														cadrul site-ului, prin accesarea uneia sau mai
														multora dintre secțiunile: creare cont,
														actualizare cont, abonare la newsletter,
														completare chestionar online, completare formular
														online, pentru obținerea de informații
														personalizate sau beneficii comerciale, în cadrul
														campaniilor promovate pe site.
													</p>
													<p className='p'>
														<strong>Temeiurile colectării</strong> pot fi:
														consimțământ; executarea unui contract; obligație
														legală; interese vitale; interes
														public/autoritate; interes legitim.
													</p>
													<p className='p'>
														<strong>Date colectate:</strong> Nume, prenume,
														e-mail, telefon, localizare, adresă de
														corespondență, link profiluri social media.
													</p>
													<p className='p'>
														<strong>Scopuri:</strong> acces la conținut,
														răspuns la solicitări, comunicări, oferte și
														beneficii privind servicii/produse.
													</p>
													<p className='p'>
														<strong>Durată:</strong> în baza de date
														securizată până la ștergere explicită sau până la
														10 ani de la ultima activitate (după care
														anonimizare).
													</p>
													<p className='p'>
														<strong>Cookies</strong>, marcaje de timp, istoric
														navigare – pentru monitorizare trafic și ierarhie
														conținut; durată similară.
													</p>
													<h3 className='h2'>
														3) Modul de păstrare a datelor, locație, perioadă
													</h3>
													<p className='p'>
														Stocăm datele pentru perioada necesară scopurilor
														prelucrării sau conform obligațiilor legale (între
														1 zi și 10 ani). Pentru detalii, consultați
														tabelul de mai sus. Implementăm măsuri tehnice și
														organizatorice speciale pentru categoriile
														sensibile.
													</p>
													<h3 className='h2'>
														4) Drepturile utilizatorilor și exercitarea
														acestora
													</h3>
													<p className='p'>
														<strong>Dreptul de acces</strong> – copii gratuite
														la prima solicitare; adrese:{" "}
														<a href='mailto:contact@Adi-Mag.ro'>
															contact@Adi-Mag.ro
														</a>
														, Str. Alexandru Sahia, Nr.15, Cugir, CUI
														RO34610550;
													</p>
													<p className='p'>
														<strong>Dreptul la rectificare</strong> –
														corectarea/ completarea datelor
														inexacte/incomplete.
													</p>
													<p className='p'>
														<strong>Dreptul la ștergere</strong> – în limitele
														legii („dreptul de a fi uitat”).
													</p>
													<p className='p'>
														<strong>Dreptul la restricționare</strong> –
														inclusiv când se contestă exactitatea.
													</p>
													<p className='p'>
														<strong>Dreptul de a obiecta</strong> – în special
														pentru marketing; datele se anonimizează prompt.
													</p>
													<p className='p'>
														<strong>
															Dreptul de a retrage consimțământul
														</strong>{" "}
														– fără a afecta legalitatea prelucrării
														anterioare; operare în max. 3 zile lucrătoare.
													</p>
													<p className='p'>
														<strong>Dreptul de a depune plângere</strong> – la
														ANSPDCP.
													</p>
													<p className='p'>
														<strong>Decizii automate &amp; profilare</strong>{" "}
														– cu consimțământ; date securizate; posibilitatea
														intervenției umane (
														<a href='mailto:contact@Adi-Mag.ro'>
															contact@Adi-Mag.ro
														</a>
														).
													</p>
													<h3 className='h2'>
														5) Exercitarea drepturilor – persoana de contact
													</h3>
													<p className='p'>
														Întrebări/cereri:{" "}
														<a href='mailto:contact@adi-mag.ro'>
															contact@adi-mag.ro
														</a>
														sau corespondență poștală la Str. Alexandru Sahia, Nr.15, Cugir CUI RO34610550
													</p>
													<h2 className='h2'>16. Forță majoră</h2>
													<p className='p'>
														Nici una din părți nu va fi răspunzătoare pentru
														neexecutarea obligațiilor sale contractuale, dacă
														o astfel de neexecutare este datorată unui
														eveniment de forță majoră. Forța majoră este
														evenimentul imprevizibil, în afara controlului
														părților și care nu poate fi evitat.
													</p>
													<h2 className='h2'>17. Legea aplicabilă</h2>
													<p className='p'>
														Prezentul contract este supus legii Române.
														Eventualele litigii apărute între Adi-Mag și
														utilizatori/clienți/cumpărători se vor rezolva pe
														cale amiabilă sau, în cazul în care aceasta nu va
														fi posibilă, litigiile vor fi soluționate de
														instanțele judecătorești Române competente.
													</p>
													<h2 className='h2'>18. Oferte speciale</h2>
													<p className='p'>
														Adi-Mag nu are în desfășurare campanii cu oferte
														speciale.
													</p>
													<h2 className='h2'>
														19. Modificarea termenilor și condițiilor
													</h2>
													<p className='p'>
														Adi-Mag are dreptul de a modifica oricând și în
														orice mod oricare dintre prevederile cuprinse în
														Termeni și condiții sau Termenii și Condițiile în
														întregime, fără nicio notificare prealabila și
														fără a fi obligata sa îndeplinească vreo alta
														formalitate fata de Utilizatori. Orice modificare
														este acceptata deplin și necondiționat de către
														Utilizatorii site-ului prin simpla utilizare sau
														accesare a site-ului sau a oricărei facilitați
														oferite de site, intervenite oricând după operarea
														modificării, iar neacceptarea oricărei modificări
														atrage obligația respectivului Utilizator de a
														înceta de îndată accesarea site-ului și/sau
														utilizarea în orice mod a serviciilor oferite prin
														intermediul acestuia.
													</p>

                                                                 <h2 className='h2'>
														20. Livrarea Produselor
													</h2>
													<p className='p'>
                                                                      Produsele comandate prin intermediul site-ului sunt livrate prin curierat rapid la adresa indicată de client, în termen de 7 zile lucrătoare de la confirmarea comenzii, în funcție de disponibilitatea produsului.
                                                                    
                                                                      NEGRU ADRIAN PERSOANA FIZICA AUTORIZATA nu este responsabilă pentru întârzierile cauzate de furnizorii de servicii de curierat sau de factori independenți de controlul său.
													</p>

                                                                 <h2 className='h2'>
														21. Dreptul De Retragere
													</h2>
													<p className='p'>
                                                                      Conform OUG nr. 34/2014, consumatorul are dreptul să se retragă din contract fără a preciza motivele, în termen de 14 zile calendaristice de la data primirii produselor.
                                                                      Pentru exercitarea acestui drept, clientul trebuie să transmită o notificare scrisă la adresa de e-mail: contact@Adi-Mag.ro.
                                                                     
                                                                      Produsele trebuie returnate în aceeași stare în care au fost livrate, împreună cu toate accesoriile și ambalajele originale.
													</p>

                                                                 <h2 className='h2'>
														22. Retururi și rambursări
													</h2>
													<p className='p'>
                                                                     După primirea și verificarea produselor returnate, NEGRU ADRIAN PERSOANA FIZICA AUTORIZATA va rambursa clientului contravaloarea produselor în termen de maximum 30 zile calendaristice, prin aceeași modalitate de plată utilizată de client la achiziție, cu excepția cazului în care s-a convenit altfel.
													</p>

                                                                 <h2 className='h2'>
														23. Soluționarea litigiilor / SAL / ODR
													</h2>
													<p className='p'>
                                                                      Eventualele neînțelegeri apărute între  și consumatori se vor rezolva pe cale amiabilă, prin contact direct (e-mail: contact@Adi-Mag.ro).
                                                                      În cazul în care soluționarea amiabilă nu este posibilă, consumatorii au dreptul de a apela la procedura de soluționare alternativă a litigiilor (SAL) prin intermediul Autorității Naționale pentru Protecția Consumatorilor (ANPC) – www.anpc.ro
                                                                      sau la platforma europeană SOL / ODR – https://ec.europa.eu/consumers/odr
.
													</p>

                                                                 <h2 className='h2'>
														24. Legea aplicabila
													</h2>
													<p className='p'>
                                                                     Prezentul contract este guvernat de legea română. Orice litigiu va fi soluționat de instanțele competente din România, în conformitate cu legislația în vigoare.
.
													</p>

                                                                 <h2 className='h2'>
														25. Destinat exclusiv consumatorilor
													</h2>
													<p className='p'>
                                                                   Site-ul Adi-Mag.ro se adresează exclusiv consumatorilor persoane fizice. Persoanele juridice (societăți comerciale, PFA, etc.) nu beneficiază de dreptul de retragere prevăzut de OUG 34/2014.
													</p>

                                                                 <p className='cookies-meta'>
                                                                      Data ultimei revizii: <strong>10 februarie 2026</strong> <br />
                                                                 </p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</article>
					</div>
				</div>
			</div>
		</>
	);
}
